import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ItemGeneralListado } from '../../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs/Observable';
import { GrowlType, AlertService } from 'app/infrastructure/services/alert.service';
import { LoaderService } from 'app/infrastructure/services/loader.service';
import { Translator } from 'angular-translator';
import { PaymentGatewayService } from 'app/infrastructure/services/payment.gateways.service';
import { PaymentGatewayModel } from 'app/infrastructure/model/interfaces/paymentGateway.interface';

@Component({
    selector: 'sx-detail-payment',
    templateUrl: './detail.payment.component.html',
})
export class DetailPaymentComponent implements OnInit {
    payment: PaymentGatewayModel;
    codSistema: string;
    pgCode: string;
    seccionActual: string;
    esNuevo = true;
    checkeandCodigo = false;
    errorCodigo = null;
    completitud = 0;

    constructor(public loaderService: LoaderService,
        private alertService: AlertService,
        private paymentSrv: PaymentGatewayService,
        private router: Router,
        private aRoute: ActivatedRoute,
        private translator: Translator) { }

    ngOnInit() {
        this.aRoute.params.subscribe((params: Params) => {
            this.codSistema = params['codsistema'];
            const operationType = params['optype'];
            this.pgCode = params['pgcode'];

            this.esNuevo = false;

            if (operationType==='nuevo') {
                this.esNuevo = true;
                this.payment = {
                    pgCode: '',
                    systemCode: this.codSistema,
                    type: 0,
                    settings: { url: undefined },
                    description: <string>this.translator.instant('PAYMENT_DESCRIPCION'),
                    status: 'A'
                };
            } else {
                this.paymentSrv
                .get(this.codSistema, this.pgCode)
                .subscribe(data => {
                    if (!data) {
                        return this.router.navigateByUrl('/soc/404');
                    }
                    this.payment = data;
                    this.inicializarCampos(data);
                });
            }
        });
    }

    validarCodigo() {
        this.errorCodigo = null;

        if (!this.payment.pgCode || this.payment.pgCode.length <= 0) {
            this.errorCodigo = 'ERR_EMPTY_PAYMENT_CODE';
            return false;
        }

        if (this.payment.pgCode.length > 40) {
            this.errorCodigo = 'ERR_PAYMENT_CODE_TOO_LONG.';
            return false;
        }

        return true;
    }

    createPayment() {
        if (!this.validarCodigo()) {
            return;
        }

        this.checkeandCodigo = true;

        // We validate if the output code is not being used
        this.paymentSrv.get(this.codSistema, this.payment.pgCode)
            .subscribe(res => {
                this.checkeandCodigo = false;
                // If the code already exists, I can not create an output
                if (res !== null) {
                    this.errorCodigo = <string>this.translator.instant('CODE_EXISTS');
                    return false;
                }

                // I create the output
                this.paymentSrv
                    .create(this.payment)
                    .then(payment => {
                        this.alertService.showGrowl({
                            type: GrowlType.SUCCESS,
                            body: 'PAYMENT_CORRECTLY_CREATED',
                        });

                        this.router.navigate(['../edit/', payment.pgCode], { relativeTo: this.aRoute.parent});

                    });
            });
    }

    editarImagen(nuevaImagen) {
        this.payment.image = nuevaImagen.imagenBase64;
        this.editPayment({ image: nuevaImagen.imagenBase64 });
    }

    editDescriptionExt(descExtChange) {
        this.payment.descriptionExt = descExtChange;
        this.editPayment({ descriptionExt: descExtChange });
    }

    private editPayment(changes) {
        this.paymentSrv.edit(this.payment.systemCode, this.payment.pgCode, changes)
            .then(data => {
                this.inicializarCampos(data);
                this.alertService.showGrowl({
                    type: GrowlType.SUCCESS,
                    body: 'EDITADO_CORRECTAMENTE',
                });
            });
    }

    private inicializarCampos(data) {
        if (data) {
            this.completitud = data.completeness ? JSON.parse(data.completeness).percentage : 0;
            this.payment.fechaActualizacion = data.fechaActualizacion;
            this.payment.modificado = data.modificado;
            this.payment.urlImage = data.urlImage;
        }
    };

    back() {
      let navigation = ['..'];
      if (!this.esNuevo) {
        navigation = ['../../'];
      }
      this.router.navigate(navigation, { relativeTo: this.aRoute });
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/paymentGateways/detail/detail.payment.component.ts